import React from 'react'
import { AccountsSheetVM } from '../../Structure/ViewModels/Admin/AccountsSheetVM'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { Col, Container, Row } from 'react-bootstrap'

const AccountsSheet = () => {
    const control = useVM<AccountsSheetVM>(new AccountsSheetVM())
  return (
    <Container>
    <div className='py-3'>
      <div className='d-flex py-2'>

        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.From} 
                onChange={a=>{ control.From=a.target.value; control.getData() } } 
            />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.To} 
                onChange={a=>{ control.To=a.target.value; control.getData() } } 
            />
        </div>
        {
            control.Data.length>0?(
                <div className='px-1 text-success d-flex'>
                    <div className='d-flex flex-column justify-content-center c-pointer'>
                        <div className=' text-center ' onClick={()=>control.downloadExcel()}>
                            {`->`} تحميل الملف
                        </div>
                    </div>
                </div>
            ):(null)
        }

      </div>
      {
        control.Show(
          <div>
            <div  className='overflow-x-auto' style={{ maxHeight:'70vh' }}>
              <table   className=' w-100 text-center' style={{minWidth:'500px'}}>
                <thead style={{ position:'sticky' }}>
                  <tr className='txt-color-I bg-light-gray'>
                    <th>الحساب</th>
                    <th>المبيعات الاساسية</th>
                    <th>المدفوعات الاضافية</th>
                  </tr>
                </thead>
                <tbody className='w-100'>
                  {
                  control.Data.map((item,index)=>(
                      <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                          <td className='text-center'>{item.account_name}</td>
                          <td className='text-center'>{item.main_value}</td>
                          <td className='text-center'>{Math.floor(Number(item.additional_value)*100)/100}</td>
                      </tr>
                  ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        )
      }
    </div>
  </Container>
  )
}

export default AccountsSheet
